import { render, staticRenderFns } from "./sendFrom.vue?vue&type=template&id=421c5780&scoped=true"
import script from "./sendFrom.vue?vue&type=script&lang=js"
export * from "./sendFrom.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "421c5780",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("E:\\a-项目\\付好佳\\多用户商城商家端\\fhj-web-dyh-mer\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('421c5780')) {
      api.createRecord('421c5780', component.options)
    } else {
      api.reload('421c5780', component.options)
    }
    module.hot.accept("./sendFrom.vue?vue&type=template&id=421c5780&scoped=true", function () {
      api.rerender('421c5780', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/order/components/sendFrom.vue"
export default component.exports